import React from 'react';
import './Btn2.css';
import btnImg from '../../asserts/btn2.png';
import { useMusic } from '../layout/MusicContext';

const Btn2 = ({ btnt, className, onClick }) => {
  const { playClick } = useMusic();
  const handleClick = (e) => {
    playClick();
    if (onClick) onClick(e);
  };
  return (
    <button className={`btn2 ${className || ''}`} onClick={handleClick}>
      <img className="btn2-bg" src={btnImg} alt="" />
      <span className="btn2-text">{btnt}</span>
    </button>
  );
};

export default Btn2;